module.exports = __webpack_public_path__ + "static/media/Use in Wondering.38c21639.jpg";